<template>
  <div class="row">
    <div class="col s12 m12">
      <div class="col s4 m4"></div>
      <div class="col s4 m4">
        <br />
        <i class="material-icons md-48 col s12 m12 center"
          >assignment_turned_in</i
        >
        <div class="input-field col s12 m12">
          <input id="usuario" type="text" class="validate" v-model="usuario" />
          <label for="first_name">Usuario</label>
        </div>
        <div class="input-field col s12 m12">
          <input
            id="contraseña"
            type="password"
            class="validate"
            v-model="contrasena"
            v-on:keyup.enter="login"
          />
          <label for="first_name">Contraseña</label>
        </div>
        <button class="btn indigo accent-2 col s12 m12 center" @click="login">
          Entrar
        </button>
      </div>
      <div class="col s4 m4"></div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
export default {
  data() {
    return {
      usuario: "",
      contrasena: "",
    };
  },
  methods: {
    login() {
      let datos = new FormData();
      datos.append("usuario", this.usuario);
      datos.append("contrasena", this.contrasena);
      axios
        .post(this.$store.state.url + "login.php", datos)
        .then((res) => {
          console.log(res.data);
          if (res.data == true) {
            // this.$store.state.id_admin = res.data;
            // console.log(res.data);
            this.$store.state.contrasena = this.contrasena;
            this.$store.state.usuario = this.usuario;
            this.$store.state.contador = 1;
          }
          if (res.data == false)
            swal("", "El usuario y/o contraseña son incorrectos", "error");
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
/* Rules for sizing the icon. */
.material-icons.md-18 {
  font-size: 18px;
}
.material-icons.md-24 {
  font-size: 24px;
}
.material-icons.md-36 {
  font-size: 36px;
}
.material-icons.md-48 {
  font-size: 48px;
}

/* Rules for using icons as black on a light background. */
.material-icons.md-dark {
  color: rgba(0, 0, 0, 0.54);
}
.material-icons.md-dark.md-inactive {
  color: rgba(0, 0, 0, 0.26);
}

/* Rules for using icons as white on a dark background. */
.material-icons.md-light {
  color: rgba(255, 255, 255, 1);
}
.material-icons.md-light.md-inactive {
  color: rgba(255, 255, 255, 0.3);
}
</style>
